import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const btnPrim = {padding: '10px 18px', background: '#0055A4', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold'};
const btnGold = {padding: '10px 18px', background: '#FFD700', color: '#0055A4', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold'};
const btnGreen = {padding: '10px 18px', background: '#28a745', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold'};
const btnOrange = {padding: '10px 18px', background: '#FF6B35', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 'bold'};
const btnGrey = {padding: '10px 18px', background: '#ccc', color: '#333', border: 'none', borderRadius: 6, cursor: 'pointer'};

const fmt = v => (v === null || v === undefined ? '-' : String(v));

const ClausuraVista = ({ isAdmin, adminPassword }) => {
  const [vista, setVista] = useState('fixture');
  const [fixture, setFixture] = useState([]);
  const [tabla, setTabla] = useState([]);
  const [clubes, setClubes] = useState([]);
  const [cuartos, setCuartos] = useState([]);
  const [semis, setSemis] = useState([]);
  const [finalP, setFinalP] = useState({});
  const [goleadores, setGoleadores] = useState([]);
  const [nuevoGol, setNuevoGol] = useState({nombre: '', club: '', goles: 0});
  const [editGol, setEditGol] = useState(null);
  const [searchGol, setSearchGol] = useState('');

  const auth = adminPassword ? `?admin_password=${encodeURIComponent(adminPassword)}` : '';

  const loadFixture = useCallback(async () => {
    const [f, t, c] = await Promise.all([
      axios.get(`${API}/clausura/fixture`),
      axios.get(`${API}/clausura/tabla`),
      axios.get(`${API}/clausura/clubes`),
    ]);
    setFixture(f.data || []);
    setTabla(t.data || []);
    setClubes(c.data.clubes || []);
  }, []);

  const loadPlayoffs = useCallback(async () => {
    const [c, s, f] = await Promise.all([
      axios.get(`${API}/clausura/cuartos`),
      axios.get(`${API}/clausura/semis`),
      axios.get(`${API}/clausura/final`),
    ]);
    setCuartos(c.data || []);
    setSemis(s.data || []);
    setFinalP(f.data || {});
  }, []);

  const loadGoleadores = useCallback(async () => {
    const r = await axios.get(`${API}/clausura/goleadores`);
    setGoleadores(r.data || []);
  }, []);

  useEffect(() => { loadFixture(); }, [loadFixture]);
  useEffect(() => {
    if (['cuartos', 'semis', 'final'].includes(vista)) loadPlayoffs();
    if (vista === 'goleadores') loadGoleadores();
  }, [vista, loadPlayoffs, loadGoleadores]);

  const cargarResultado = async (fecha, idx, eq1, eq2, actual) => {
    if (!isAdmin) return alert('Ingresá como admin');
    const g1 = window.prompt(`${eq1} - Goles (vacío para borrar):`, actual?.goles1 ?? '');
    if (g1 === null) return;
    const g2 = window.prompt(`${eq2} - Goles (vacío para borrar):`, actual?.goles2 ?? '');
    if (g2 === null) return;
    const body = {
      fecha, partido_idx: idx,
      goles1: g1 === '' ? null : parseInt(g1),
      goles2: g2 === '' ? null : parseInt(g2),
    };
    try {
      await axios.post(`${API}/clausura/resultado${auth}`, body);
      loadFixture();
    } catch (err) {
      alert('❌ ' + (err.response?.data?.detail || err.message));
    }
  };

  const generarCuartos = async () => {
    if (!isAdmin) return;
    if (!window.confirm('¿Generar cuartos automáticamente desde la tabla actual (top 8)?')) return;
    try {
      // force=true porque el usuario ya confirmó arriba
      const r = await axios.post(`${API}/clausura/playoffs/auto${auth}&force=true`);
      alert('✅ Cuartos generados:\n' + r.data.cruces.map(([a,b]) => `${a} vs ${b}`).join('\n'));
      loadPlayoffs();
    } catch (err) {
      alert('❌ ' + (err.response?.data?.detail || err.message));
    }
  };

  const editarFase = async (endpoint, partido_idx, campo, extra = {}) => {
    if (!isAdmin) return;
    const collection = endpoint === 'cuartos' ? cuartos : semis;
    const p = collection[partido_idx] || {};
    let updates = { partido_idx, equipo1: p.equipo1 || '', equipo2: p.equipo2 || '',
      goles_ida_1: p.goles_ida_1, goles_ida_2: p.goles_ida_2,
      goles_vuelta_1: p.goles_vuelta_1, goles_vuelta_2: p.goles_vuelta_2,
      penales1: p.penales1, penales2: p.penales2, ...extra };
    if (campo === 'equipos') {
      const e1 = window.prompt('Club 1 (vacío para borrar):', p.equipo1 || '');
      const e2 = window.prompt('Club 2 (vacío para borrar):', p.equipo2 || '');
      if (e1 === null || e2 === null) return;
      updates.equipo1 = e1; updates.equipo2 = e2;
    } else if (campo === 'ida') {
      const g1 = window.prompt(`Goles IDA ${p.equipo1||'Club 1'} (vacío=borrar):`, p.goles_ida_1 ?? '');
      const g2 = window.prompt(`Goles IDA ${p.equipo2||'Club 2'} (vacío=borrar):`, p.goles_ida_2 ?? '');
      if (g1 === null || g2 === null) return;
      updates.goles_ida_1 = g1 === '' ? null : parseInt(g1);
      updates.goles_ida_2 = g2 === '' ? null : parseInt(g2);
    } else if (campo === 'vuelta') {
      const g1 = window.prompt(`Goles VUELTA ${p.equipo2||'Club 2'} (local invertido, vacío=borrar):`, p.goles_vuelta_1 ?? '');
      const g2 = window.prompt(`Goles VUELTA ${p.equipo1||'Club 1'} (vacío=borrar):`, p.goles_vuelta_2 ?? '');
      if (g1 === null || g2 === null) return;
      updates.goles_vuelta_1 = g1 === '' ? null : parseInt(g1);
      updates.goles_vuelta_2 = g2 === '' ? null : parseInt(g2);
    } else if (campo === 'penales') {
      const g1 = window.prompt(`Penales ${p.equipo1||'Club 1'}:`, p.penales1 ?? '');
      const g2 = window.prompt(`Penales ${p.equipo2||'Club 2'}:`, p.penales2 ?? '');
      if (g1 === null || g2 === null) return;
      updates.penales1 = g1 === '' ? null : parseInt(g1);
      updates.penales2 = g2 === '' ? null : parseInt(g2);
    }
    try {
      await axios.post(`${API}/clausura/${endpoint}${auth}`, updates);
      loadPlayoffs();
    } catch (err) {
      alert('❌ ' + (err.response?.data?.detail || err.message));
    }
  };

  const editarFinal = async (campo) => {
    if (!isAdmin) return;
    let updates = { equipo1: finalP.equipo1 || '', equipo2: finalP.equipo2 || '',
      goles1: finalP.goles1, goles2: finalP.goles2, penales1: finalP.penales1, penales2: finalP.penales2 };
    if (campo === 'goles') {
      const g1 = window.prompt(`Goles ${finalP.equipo1||'Club 1'}:`, finalP.goles1 ?? '');
      const g2 = window.prompt(`Goles ${finalP.equipo2||'Club 2'}:`, finalP.goles2 ?? '');
      if (g1 === null || g2 === null) return;
      updates.goles1 = g1 === '' ? null : parseInt(g1);
      updates.goles2 = g2 === '' ? null : parseInt(g2);
    } else if (campo === 'penales') {
      const g1 = window.prompt(`Penales ${finalP.equipo1||'Club 1'}:`, finalP.penales1 ?? '');
      const g2 = window.prompt(`Penales ${finalP.equipo2||'Club 2'}:`, finalP.penales2 ?? '');
      if (g1 === null || g2 === null) return;
      updates.penales1 = g1 === '' ? null : parseInt(g1);
      updates.penales2 = g2 === '' ? null : parseInt(g2);
    }
    try {
      await axios.post(`${API}/clausura/final${auth}`, updates);
      loadPlayoffs();
    } catch (err) {
      alert('❌ ' + (err.response?.data?.detail || err.message));
    }
  };

  const RSS_URL = 'https://encfutsalfifa.com.py/api/clausura/rss/clausura-2026.xml';
  const [rssCopied, setRssCopied] = useState(false);

  const copiarRSS = async () => {
    try {
      await navigator.clipboard.writeText(RSS_URL);
      setRssCopied(true);
      setTimeout(() => setRssCopied(false), 2500);
    } catch {
      window.prompt('Copiá la URL del RSS:', RSS_URL);
    }
  };

  const addGoleador = async () => {
    if (!nuevoGol.nombre || !nuevoGol.club) return alert('Completá nombre y club');
    try {
      await axios.post(`${API}/clausura/goleadores${auth}`, nuevoGol);
      setNuevoGol({nombre: '', club: '', goles: 0});
      loadGoleadores();
    } catch (err) { alert('❌ ' + (err.response?.data?.detail || err.message)); }
  };
  const saveEditGol = async () => {
    try {
      await axios.put(`${API}/clausura/goleadores/${editGol.id}${auth}`, {
        nombre: editGol.nombre, club: editGol.club, goles: parseInt(editGol.goles) || 0,
      });
      setEditGol(null);
      loadGoleadores();
    } catch (err) { alert('❌ ' + (err.response?.data?.detail || err.message)); }
  };
  const delGoleador = async (id) => {
    if (!window.confirm('¿Eliminar goleador?')) return;
    try {
      await axios.delete(`${API}/clausura/goleadores/${id}${auth}`);
      loadGoleadores();
    } catch (err) { alert('❌ ' + (err.response?.data?.detail || err.message)); }
  };

  return (
    <div style={{padding: 15}} data-testid="clausura-vista">
      <h3 style={{color: '#0055A4', textAlign: 'center', marginTop: 0}}>🏆 CAMPEONATO CLAUSURA — SUPERLIGA SERIE A 2026</h3>

      <div style={{display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 20}}>
        {[
          ['fixture', '📅 FIXTURE', btnPrim],
          ['tabla', '📊 TABLA', btnGold],
          ['goleadores', '⚽ GOLEADORES', btnGreen],
          ['cuartos', '🔥 CUARTOS', btnOrange],
          ['semis', '🥈 SEMIS', btnOrange],
          ['final', '🏆 FINAL', btnGold],
        ].map(([key, label, activeStyle]) => (
          <button key={key} onClick={() => setVista(key)}
            data-testid={`clausura-tab-${key}`}
            style={vista === key ? activeStyle : btnGrey}>{label}</button>
        ))}
      </div>

      {isAdmin && (
        <div data-testid="clausura-rss-bar" style={{background: '#0055A4', color: 'white', padding: '10px 14px', borderRadius: 8, marginBottom: 16, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10}}>
          <span style={{fontWeight: 'bold', fontSize: '.95em'}}>📡 RSS del Clausura 2026:</span>
          <code style={{background: 'rgba(255,255,255,.15)', padding: '4px 8px', borderRadius: 4, fontSize: '.85em', flex: '1 1 300px', overflowWrap: 'anywhere'}}>{RSS_URL}</code>
          <button onClick={copiarRSS} data-testid="clausura-copy-rss-btn" style={{padding: '6px 14px', background: rssCopied ? '#28a745' : '#FFD700', color: '#0055A4', border: 'none', borderRadius: 5, cursor: 'pointer', fontWeight: 'bold'}}>
            {rssCopied ? '✓ Copiado' : '📋 COPIAR RSS'}
          </button>
          <a href={RSS_URL} target="_blank" rel="noopener noreferrer" data-testid="clausura-open-rss-link" style={{color: '#FFD700', textDecoration: 'underline', fontSize: '.85em'}}>Abrir feed</a>
        </div>
      )}

      {vista === 'fixture' && (
        <div data-testid="clausura-fixture">
          {fixture.map(f => (
            <div key={f.fecha} style={{background: 'white', padding: 12, marginBottom: 10, borderRadius: 8, boxShadow: '0 2px 6px rgba(0,0,0,.08)'}}>
              <h4 style={{color: '#0055A4', margin: '0 0 8px'}}>FECHA {f.fecha}</h4>
              {f.partidos.map((p) => {
                const jugado = p.goles1 !== null && p.goles1 !== undefined;
                return (
                  <div key={p.idx} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: '1px solid #eee', background: jugado ? '#f0fff0' : 'transparent'}}>
                    <span style={{flex: 1}}>
                      {jugado ? (<><strong>{p.equipo1}</strong> <b style={{color:'#0055A4'}}>{p.goles1}</b> - <b style={{color:'#0055A4'}}>{p.goles2}</b> <strong>{p.equipo2}</strong></>)
                              : (<>{p.equipo1} <span style={{color:'#999'}}>vs</span> {p.equipo2}</>)}
                    </span>
                    {isAdmin && <button data-testid={`clausura-load-${f.fecha}-${p.idx}`} onClick={() => cargarResultado(f.fecha, p.idx, p.equipo1, p.equipo2, p)}
                      style={{padding: '4px 12px', background: jugado ? '#ffc107' : '#28a745', color: jugado ? '#333' : 'white', border:'none', borderRadius: 5, cursor: 'pointer', fontSize: '.85em'}}>{jugado ? '✏️' : '⚽'}</button>}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}

      {vista === 'tabla' && (
        <div style={{background: 'white', padding: 15, borderRadius: 8, overflowX: 'auto'}} data-testid="clausura-tabla">
          <table style={{width: '100%', borderCollapse: 'collapse', fontSize: '.9em'}}>
            <thead>
              <tr style={{background: '#0055A4', color: 'white'}}>
                {['POS','CLUB','PJ','PG','PE','PP','GF','GC','DG','PTS'].map(h => (
                  <th key={h} style={{padding: 8, textAlign: h === 'CLUB' ? 'left' : 'center'}}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tabla.map((t, i) => {
                const dg = (t.gf || 0) - (t.gc || 0);
                const clasif = i < 8;
                return (
                  <tr key={t.equipo} style={{background: clasif ? '#DFF5E1' : '#FFE1E1', borderBottom: '1px solid #ddd'}}>
                    <td style={{padding: 6, textAlign: 'center', fontWeight: 'bold'}}>{i+1}</td>
                    <td style={{padding: 6, fontWeight: 'bold'}}>{t.equipo}</td>
                    {['pj','pg','pe','pp','gf','gc'].map(k => <td key={k} style={{padding: 6, textAlign: 'center'}}>{t[k] || 0}</td>)}
                    <td style={{padding: 6, textAlign: 'center'}}>{dg}</td>
                    <td style={{padding: 6, textAlign: 'center', fontWeight: 'bold', color: '#0055A4'}}>{t.pts || 0}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <p style={{fontSize: '.85em', marginTop: 10, color: '#666'}}>🟢 Clasifican 1° al 8° &nbsp;|&nbsp; 🔴 Eliminados 9° al 12°</p>
        </div>
      )}

      {vista === 'goleadores' && (
        <div style={{background: 'white', padding: 15, borderRadius: 8}} data-testid="clausura-goleadores">
          {isAdmin && (
            <div style={{marginBottom: 15, padding: 12, background: '#f8f9fa', borderRadius: 6}}>
              <h4 style={{margin: '0 0 10px'}}>➕ Agregar goleador</h4>
              <div style={{display: 'flex', gap: 8, flexWrap: 'wrap'}}>
                <input placeholder="Nombre y apellido" data-testid="gol-nombre" value={nuevoGol.nombre} onChange={e => setNuevoGol({...nuevoGol, nombre: e.target.value})} style={{padding: 8, flex: '1 1 200px', border: '1px solid #ccc', borderRadius: 4}} />
                <select data-testid="gol-club" value={nuevoGol.club} onChange={e => setNuevoGol({...nuevoGol, club: e.target.value})} style={{padding: 8, flex: '1 1 180px', border: '1px solid #ccc', borderRadius: 4}}>
                  <option value="">-- Club --</option>
                  {clubes.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
                <input type="number" min="0" placeholder="Goles" data-testid="gol-goles" value={nuevoGol.goles} onChange={e => setNuevoGol({...nuevoGol, goles: parseInt(e.target.value)||0})} style={{padding: 8, width: 80, border: '1px solid #ccc', borderRadius: 4}} />
                <button onClick={addGoleador} data-testid="gol-add" style={btnGreen}>➕ Agregar</button>
              </div>
              <div style={{marginTop: 12, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap'}}>
                <span style={{fontSize: '.9em', color: '#555', fontWeight: 600}}>🔍 Buscar:</span>
                <input
                  data-testid="gol-search"
                  placeholder="Filtrar por jugador o club..."
                  value={searchGol}
                  onChange={e => setSearchGol(e.target.value)}
                  style={{padding: 8, flex: '1 1 260px', border: '1px solid #ccc', borderRadius: 4}}
                />
                {searchGol && (
                  <button
                    data-testid="gol-search-clear"
                    onClick={() => setSearchGol('')}
                    style={{...btnGrey, padding: '6px 10px', fontSize: '.85em'}}
                  >✖ Limpiar</button>
                )}
                <span style={{fontSize: '.85em', color: '#777'}}>
                  {(() => {
                    const q = searchGol.trim().toLowerCase();
                    const c = q ? goleadores.filter(g => (g.nombre||'').toLowerCase().includes(q) || (g.club||'').toLowerCase().includes(q)).length : goleadores.length;
                    return `${c} resultado${c === 1 ? '' : 's'}`;
                  })()}
                </span>
              </div>
            </div>
          )}
          <table style={{width: '100%', borderCollapse: 'collapse'}}>
            <thead><tr style={{background: '#0055A4', color: 'white'}}>
              <th style={{padding: 8}}>POS</th><th style={{padding: 8, textAlign: 'left'}}>JUGADOR</th>
              <th style={{padding: 8, textAlign: 'left'}}>CLUB</th><th style={{padding: 8}}>GOLES</th>
              {isAdmin && <th style={{padding: 8}}>ACCIONES</th>}
            </tr></thead>
            <tbody>
              {(() => {
                const q = isAdmin ? searchGol.trim().toLowerCase() : '';
                let rows = goleadores.map((g, i) => ({g, pos: i}));
                if (q) {
                  rows = rows
                    .filter(({g}) => (g.nombre||'').toLowerCase().includes(q) || (g.club||'').toLowerCase().includes(q))
                    .sort((a, b) => (a.g.nombre||'').localeCompare(b.g.nombre||'', 'es', {sensitivity: 'base'}));
                }
                if (rows.length === 0) {
                  return <tr><td colSpan={isAdmin ? 5 : 4} style={{padding: 15, textAlign: 'center', color: '#999'}}>{q ? 'Sin resultados para la búsqueda.' : 'Sin goleadores cargados aún.'}</td></tr>;
                }
                return rows.map(({g, pos: i}) => editGol && editGol.id === g.id ? (
                <tr key={g.id} style={{background: '#fff3cd'}}>
                  <td style={{padding: 6, textAlign: 'center'}}>{i+1}</td>
                  <td style={{padding: 6}}><input value={editGol.nombre} onChange={e => setEditGol({...editGol, nombre: e.target.value})} style={{padding: 4, width: '95%'}} /></td>
                  <td style={{padding: 6}}>
                    <select value={editGol.club} onChange={e => setEditGol({...editGol, club: e.target.value})} style={{padding: 4, width: '95%'}}>
                      {clubes.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </td>
                  <td style={{padding: 6}}><input type="number" min="0" value={editGol.goles} onChange={e => setEditGol({...editGol, goles: e.target.value})} style={{padding: 4, width: 60}} /></td>
                  <td style={{padding: 6, textAlign: 'center'}}>
                    <button onClick={saveEditGol} style={{...btnGreen, padding: '4px 8px', fontSize: '.85em'}}>💾</button>
                    <button onClick={() => setEditGol(null)} style={{...btnGrey, padding: '4px 8px', marginLeft: 4, fontSize: '.85em'}}>✖</button>
                  </td>
                </tr>
              ) : (
                <tr key={g.id} style={{borderBottom: '1px solid #eee', background: i < 3 ? '#FFF3C4' : 'transparent'}}>
                  <td style={{padding: 6, textAlign: 'center', fontWeight: 'bold'}}>{i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : i+1}</td>
                  <td style={{padding: 6}}>{g.nombre}</td>
                  <td style={{padding: 6, color: '#666'}}>{g.club}</td>
                  <td style={{padding: 6, textAlign: 'center', fontWeight: 'bold', color: '#FF6B35', fontSize: '1.1em'}}>{g.goles}</td>
                  {isAdmin && (
                    <td style={{padding: 6, textAlign: 'center'}}>
                      <button data-testid={`gol-edit-${g.id}`} onClick={() => setEditGol({...g})} style={{...btnGold, padding: '4px 8px', fontSize: '.85em'}}>✏️</button>
                      <button data-testid={`gol-del-${g.id}`} onClick={() => delGoleador(g.id)} style={{padding: '4px 8px', marginLeft: 4, background: '#dc3545', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: '.85em'}}>🗑</button>
                    </td>
                  )}
                </tr>
              ));
              })()}
            </tbody>
          </table>
        </div>
      )}

      {vista === 'cuartos' && (
        <div style={{background: 'white', padding: 15, borderRadius: 8}} data-testid="clausura-cuartos">
          {isAdmin && (
            <button onClick={generarCuartos} data-testid="clausura-gen-cuartos" style={{...btnPrim, marginBottom: 15}}>⚡ Autogenerar cuartos desde tabla</button>
          )}
          {cuartos.length === 0 && <p style={{color: '#666'}}>Aún no se generaron los cuartos. Usá el botón "Autogenerar" o cargá los clubes manualmente.</p>}
          {cuartos.map((c, i) => <FaseCard key={i} etiqueta={`Cuarto ${['A','B','C','D'][i]}`} p={c} isAdmin={isAdmin} onEdit={(campo) => editarFase('cuartos', i, campo)} />)}
        </div>
      )}

      {vista === 'semis' && (
        <div style={{background: 'white', padding: 15, borderRadius: 8}} data-testid="clausura-semis">
          {semis.length === 0 && <p style={{color: '#666'}}>Las semifinales se completarán automáticamente al finalizar los cuartos.</p>}
          {semis.map((s, i) => <FaseCard key={i} etiqueta={`Semifinal ${i+1}`} p={s} isAdmin={isAdmin} onEdit={(campo) => editarFase('semis', i, campo)} />)}
        </div>
      )}

      {vista === 'final' && (
        <div style={{background: 'linear-gradient(135deg,#FFD700,#FFA500)', padding: 25, borderRadius: 12}} data-testid="clausura-final">
          <h3 style={{color: '#0055A4', textAlign: 'center', marginTop: 0, fontSize: '1.6em'}}>🏆 LA GRAN FINAL</h3>
          <div style={{background: 'white', padding: 20, borderRadius: 10, maxWidth: 700, margin: '0 auto'}}>
            <p style={{margin: '0 0 15px', fontSize: '1.1em'}}><b>{finalP.equipo1 || '—'}</b> <span style={{color:'#999'}}>vs</span> <b>{finalP.equipo2 || '—'}</b></p>
            <p style={{fontSize: '2.4em', textAlign: 'center', margin: '10px 0', fontWeight: 'bold', color: '#FF6B35'}}>{fmt(finalP.goles1)} - {fmt(finalP.goles2)}</p>
            {(finalP.goles1 !== null && finalP.goles1 === finalP.goles2 || finalP.penales1 !== null) && (
              <p style={{textAlign: 'center', fontSize: '1.1em'}}>Penales: <b>{fmt(finalP.penales1)}</b> - <b>{fmt(finalP.penales2)}</b></p>
            )}
            {isAdmin && (
              <div style={{display: 'flex', gap: 8, justifyContent: 'center', marginTop: 15, flexWrap: 'wrap'}}>
                <button onClick={() => editarFinal('goles')} data-testid="clausura-final-goles" style={btnGreen}>⚽ Editar Goles</button>
                <button onClick={() => editarFinal('penales')} data-testid="clausura-final-penales" style={btnOrange}>🎯 Editar Penales</button>
              </div>
            )}
            {finalP.ganador && (
              <div style={{marginTop: 20, padding: 15, background: '#FFD700', borderRadius: 8, textAlign: 'center'}}>
                <h2 style={{margin: 0, color: '#0055A4'}}>🎉 CAMPEÓN: {finalP.ganador} 🎉</h2>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const FaseCard = ({ etiqueta, p, isAdmin, onEdit }) => {
  const tieneIda = p.goles_ida_1 !== null && p.goles_ida_1 !== undefined;
  const tieneVuelta = p.goles_vuelta_1 !== null && p.goles_vuelta_1 !== undefined;
  const tienePenales = p.penales1 !== null && p.penales1 !== undefined;
  return (
    <div style={{border: '2px solid #FF6B35', padding: 12, borderRadius: 8, marginBottom: 12, background: '#fff8f5'}}>
      <h4 style={{color: '#FF6B35', margin: '0 0 10px'}}>{etiqueta}</h4>
      <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap'}}>
        <span style={{minWidth: 60, fontWeight: 'bold'}}>Clubes:</span>
        <span style={{flex: 1, padding: 6, background: '#f0f0f0', borderRadius: 4, minHeight: 20}}>{p.equipo1 || '—'}</span>
        <span>vs</span>
        <span style={{flex: 1, padding: 6, background: '#f0f0f0', borderRadius: 4, minHeight: 20}}>{p.equipo2 || '—'}</span>
        {isAdmin && <button onClick={() => onEdit('equipos')} style={{...btnGold, padding: '4px 8px'}}>✏️</button>}
      </div>
      <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap'}}>
        <span style={{minWidth: 60, fontWeight: 'bold'}}>Ida:</span>
        <span style={{padding: '6px 12px', background: '#e8f5e9', borderRadius: 4, fontWeight: 'bold'}}>{tieneIda ? p.goles_ida_1 : '-'}</span>
        <span>-</span>
        <span style={{padding: '6px 12px', background: '#e8f5e9', borderRadius: 4, fontWeight: 'bold'}}>{tieneIda ? p.goles_ida_2 : '-'}</span>
        {isAdmin && <button onClick={() => onEdit('ida')} style={{...btnGreen, padding: '4px 8px'}}>⚽</button>}
      </div>
      <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap'}}>
        <span style={{minWidth: 60, fontWeight: 'bold'}}>Vuelta:</span>
        <span style={{padding: '6px 12px', background: '#fff3e0', borderRadius: 4, fontWeight: 'bold'}}>{tieneVuelta ? p.goles_vuelta_1 : '-'}</span>
        <span>-</span>
        <span style={{padding: '6px 12px', background: '#fff3e0', borderRadius: 4, fontWeight: 'bold'}}>{tieneVuelta ? p.goles_vuelta_2 : '-'}</span>
        <span style={{fontSize: '.75em', color: '#666'}}>(localía invertida)</span>
        {isAdmin && <button onClick={() => onEdit('vuelta')} style={{...btnOrange, padding: '4px 8px'}}>⚽</button>}
      </div>
      {p.requiere_penales && (
        <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap'}}>
          <span style={{minWidth: 60, fontWeight: 'bold'}}>Penales:</span>
          <span style={{padding: '6px 12px', background: '#ffe0e0', borderRadius: 4, fontWeight: 'bold'}}>{tienePenales ? p.penales1 : '-'}</span>
          <span>-</span>
          <span style={{padding: '6px 12px', background: '#ffe0e0', borderRadius: 4, fontWeight: 'bold'}}>{tienePenales ? p.penales2 : '-'}</span>
          {isAdmin && <button onClick={() => onEdit('penales')} style={{...btnOrange, padding: '4px 8px'}}>🎯</button>}
        </div>
      )}
      {p.ganador && <p style={{margin: '8px 0 0', color: '#0055A4', fontWeight: 'bold'}}>✅ Ganador: {p.ganador}</p>}
      {p.requiere_penales && !tienePenales && <p style={{margin: '8px 0 0', color: '#856404', fontWeight: 'bold', fontSize: '.9em'}}>⚠️ Empate en victorias — cargá los penales para definir.</p>}
    </div>
  );
};

export default ClausuraVista;
